import React, { useEffect, useState } from 'react';
import { 
  Container, Typography, Table, TableBody, TableCell, 
  TableContainer, TableHead, TableRow, Paper, Link, TableSortLabel 
} from '@mui/material';
import { fetchRanking } from '../lib/api';

const Ranking = () => {
  const [rankingData, setRankingData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState("asc"); // ✅ デフォルトを昇順（asc）
  const [orderBy, setOrderBy] = useState("MODELRANK"); // ✅ デフォルトのソートカラムを "MODELRANK"
  const [rowsPerPage, setRowsPerPage] = useState(200); // ✅ 1ページの表示件数（10行）
  const [page, setPage] = useState(0); // ✅ 現在のページ

  useEffect(() => {
    const getRanking = async () => {
      try {
        const data = await fetchRanking();
        setRankingData(data);
      } catch (error) {
        console.error("ランキングの取得に失敗しました:", error);
      } finally {
        setLoading(false);
      }
    };
    getRanking();
  }, []);

  // ソート処理
  const handleSortRequest = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // データソート関数
  const sortedData = [...rankingData].sort((a, b) => {
    if (a[orderBy] < b[orderBy]) return order === "asc" ? -1 : 1;
    if (a[orderBy] > b[orderBy]) return order === "asc" ? 1 : -1;
    return 0;
  });

  // 現在のページのデータ取得
  const paginatedData = sortedData.slice(0, (page + 1) * rowsPerPage);

  // スクロールでさらにデータを読み込む
  const handleScroll = (event) => {
    const bottom = event.target.scrollHeight - event.target.scrollTop === event.target.clientHeight;
    if (bottom) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  if (loading) {
    return (
      <Container sx={{ py: 4, textAlign: 'center' }}>
        <Typography variant="body1">ランキングを読み込み中...</Typography>
      </Container>
    );
  }

  return (
    <Container sx={{ py: 4 }}>
      {/* タイトル & 説明 */}
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Chatbot Arena
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        AIモデルの実力を、ユーザーの投票で直接競わせるプラットフォーム。
        GPT-4やClaude、Geminiなどの最新モデルが匿名で対決し、どちらが優れた応答をするかを選ぶシンプルな仕組み。
        投票結果はランキングに反映され、リアルタイムでAIの勢力図が変わっていく。
      </Typography>

      {/* テーブルコンテナ（スクロール時に追加読み込み） */}
      <TableContainer component={Paper} sx={{ maxHeight: "500px", overflowY: "auto" }} onScroll={handleScroll}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {[
                { id: "MODELRANK", label: "Rank" },
                { id: "MODELNAME", label: "Model Name" },
                { id: "ARENA_SCORE", label: "Score" },
                { id: "VOTES", label: "Votes" },
                { id: "ORGANIZATION", label: "Organization" },
                { id: "LICENCE", label: "License" },
              ].map((column) => (
                <TableCell key={column.id}>
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={orderBy === column.id ? order : "asc"}
                    onClick={() => handleSortRequest(column.id)}
                  >
                    {column.label}
                  </TableSortLabel>
                </TableCell>
              ))}
              <TableCell>URL</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{row.MODELRANK}</TableCell>
                <TableCell>{row.MODELNAME}</TableCell>
                <TableCell>{row.ARENA_SCORE}</TableCell>
                <TableCell>{row.VOTES}</TableCell>
                <TableCell>{row.ORGANIZATION}</TableCell>
                <TableCell>{row.LICENCE}</TableCell>
                <TableCell>
                  <Link href={row.URL} target="_blank" rel="noopener noreferrer">
                    Source
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default Ranking;